export default "__VITE_ASSET__e0234d13__$_?component__"